<div siqGrid fx-direction="column" [fx-layout-align]="itemsLayoutAlign" fx-layout-align-lt-sm="center start">
  @for(item of items; track $index) {
    <div [class]="itemsClasses">
      <div siqGrid fx-direction="row" fx-layout-align="start center">
        <span [class]="oneItemClasses(item.icon)"></span>
        <div [class]="textMargin">
          <span [class]="item.textClasses" [innerHTML]="item.text"></span>
        </div>
      </div>  
    </div>
  }
</div>
